import "core-js/modules/es6.regexp.split";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import _values from "lodash/values";
import _isPlainObject from "lodash/isPlainObject";
export default {
  currentImage: function currentImage(state) {
    return state.currentImage;
  },
  productInspiration: function productInspiration(state) {
    return state.productInspiration;
  },
  productCross: function productCross(state) {
    return state.productCross;
  },
  productComplementary: function productComplementary(state) {
    return state.productComplementary;
  },
  variants: function variants(state) {
    return state.variants;
  },
  product: function product(state) {
    return state.product;
  },
  tc_vars: function tc_vars(state) {
    return state.productNav.tc_vars.params;
  },
  tracking: function tracking(state) {
    return state.productNav.product.click_tracking;
  },
  salesPromotion: function salesPromotion(state) {
    return state.productNav.sales_promotion;
  },
  estimatedDelivery: function estimatedDelivery(state) {
    return state.productNav.product.estimated_delivery;
  },
  delivery: function delivery(state) {
    var delivery = {
      home: null,
      store: null
    };

    if (state.productNav.product.estimated_delivery && state.productNav.product.estimated_delivery.translation && state.productNav.product.estimated_delivery.translation.classic) {
      var _state$productNav$pro = state.productNav.product.estimated_delivery.translation.classic.split(';');

      var _state$productNav$pro2 = _slicedToArray(_state$productNav$pro, 2);

      delivery.home = _state$productNav$pro2[1];
    }

    if (state.productNav.product.estimated_delivery && state.productNav.product.estimated_delivery.lgm_eligible && state.productNav.product.estimated_delivery.translation && state.productNav.product.estimated_delivery.translation.lgm) {
      var _state$productNav$pro3 = state.productNav.product.estimated_delivery.translation.lgm.split(';');

      var _state$productNav$pro4 = _slicedToArray(_state$productNav$pro3, 2);

      delivery.store = _state$productNav$pro4[1];
    }

    return delivery;
  },
  categorySticker: function categorySticker(state) {
    return _isPlainObject(state.productNav.product.segmentations.category_sticker) ? _values(state.productNav.product.segmentations.category_sticker) : state.productNav.product.segmentations.category_sticker;
  },
  gamme: function gamme(state) {
    return state.productNav.product.cross.gamme;
  },
  olapic: function olapic(state) {
    return state.productNav.product.olapic;
  }
};